
import React, { useState, useEffect, useContext } from 'react';
import { addBusinessDays } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';
import { FaSackDollar } from "react-icons/fa6";
import { IoMdCheckmark } from 'react-icons/io';
import { BsFillSendFill } from "react-icons/bs";
import { Layout, Header } from '../../../../components';
import { handleApi, formatCurrency, formatMediumDate } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Pay = () => {
  const location = useLocation();
  const { pay } = location.state || {};
  console.log('payment in pay',pay)
  const clearPayeeFields = () => {
    return {
      payee_name: '',
      id_type: '',
      id_no: '',
      account_holder_name: '',
      bank_account_number: '',
      bank_branch: '',
      bank_name: '',
      cheque_no: '',
      credit_card_number: '',
      credit_card_expiration_date: '',
      cvv: '',
      paypal_email: '',
      currency: '',
      mobile_number: '',
      service_provider: ''
    };
  };
  
  const [payment, setPayment] = useState({
    state: pay?.state,
    invoice_id: pay?.id || 0,
    method_id: pay?.method_id,
    amount: pay?.amount || 0,
    payee: clearPayeeFields(),  // Calling the function to initialize the payee object
  });
    
  const identityTypes = [
    { value: 'national_id', label: 'National Id' },
    { value: 'passport', label: 'Passport' },
    { value: 'driving_licence', label: 'Driving Licence' },
  ];
    const currencyOptions = [   // Define  currency options
      { value: 'USD', label: 'USD' },
      { value: 'EUR', label: 'EUR' },
      { value: 'GBP', label: 'GBP' },
    ];
    

  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [formattedPaymentMethods, setFormattedPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null); // The customer object
  const [installments, setInstallments] = useState([]);
  const [showPaymentButton, setShowPaymentButton] = useState(true);
  const [isInstallment,setIsInstallment] = useState(pay?.amount < pay?.invoice?.totalTaxedPrice);

  console.log('isInstallment sir',isInstallment)
  const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
  const navigate = useNavigate();

  // Update isInstallment whenever pay changes
  // Update isInstallment when pay.amount or pay.invoice.totalTaxedPrice changes


  
  useEffect(() => {
    setIsInstallment(pay?.amount < pay?.invoice?.totalTaxedPrice);
  }, [pay?.amount, pay?.invoice?.totalTaxedPrice]);

  useEffect(() => {
    if (pay?.method_id) {
      const preselectedMethod = formattedPaymentMethods.find(method => method.value === pay.method_id);
      setSelectedPaymentMethod(preselectedMethod);
    }
  }, [formattedPaymentMethods, pay?.method_id]);
  
  const handleApiWithTimeout = async (url, data, userData, method, parameters, timeout = 5000) => { // Timeout helper for API calls
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await handleApi(url, data, userData, method, parameters, { signal: controller.signal });
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        toast.error('Request timed out');
      } else {
        toast.error('Error: ' + error.message);
      }
      throw error;
    } finally {
      clearTimeout(timeoutId);
    }
  };
  
  
  const handlePaymentChange = async (field, value) => {
   setPayment((prevPayment) => {
     let newPayment = { ...prevPayment };
 
    
    if (field === 'installments') {   
       setIsInstallment(value);   // Handle the installment checkbox change
       newPayment.amount = value ? prevPayment.installment_amount : pay?.totalTaxedPrice || 0;
     }else if (field === 'installment_amount') { newPayment.amount = value; 
     }else if (field === 'method_id') { // Find the selected payment method object
      const selectedMethod = formattedPaymentMethods.find(option => option.value === value);
      newPayment.method_id = value;
      setSelectedPaymentMethod(selectedMethod);  // Set the object with value and label
      newPayment.payee = clearPayeeFields();  // Reset all payee fields
     } else {newPayment[field] = value;    // If it's not a payee field, update the field directly on payment
    }
 

     return newPayment;
   });
 };
  
 const handleSubmit = async () => {
     const changedOrder = { state: "paid", id: pay.id }; // Ensure this is populated if needed
     const parameters = {}; // Make sure this is populated if needed
     setIsLoading(true); // Start loading
 
     try {
       const response = await handleApiWithTimeout('purchase/payments', changedOrder, userData, 'PUT', parameters);
       console.log("API Response:", response);  // Log the API response to see if we are getting the expected data
       if (response.status === 200) {
         toast.success('Payment successfully.');

       } else {
         toast.error('Error making payment.', response.statusText);
       }
     } catch (error) {
       console.error("API Error:", error);  // Log any error that might occur
       toast.error('Error making payment: ' + error.message);
     } finally {
       setIsLoading(false); // Always stop loading after request is done
       setActionCount(actionCount + 1); // Update action count
     }
   };
  

  const handleClose = () => { 
    navigate(-1);  // Navigate back when closing the form
  };

  const subtotal = pay?.invoice?.totalUntaxedPrice || 0;
  const discountAmount = pay?.totalDiscount || 0;
  const subtotalAfterDiscount = subtotal - discountAmount;
  const taxAmount = pay?.invoice?.totalTax || 0;
  const grandTotal = subtotalAfterDiscount + taxAmount;

  const formattedGrandTotal = formatCurrency(grandTotal.toFixed(2));
  console.log('payment sir ',payment)
  return (
    <Layout>
      <div className="m-4 bg-black rounded-xl shadow-2xl">
        <ToastContainer position="top-center" autoClose={2000} />

        {/* Header Section */}
        <div className="text-center  border-b">
          <div className="w-full flex justify-end">
            <button
              className="text-white hover:text-gray-300 py-1 px-2 rounded transition-all duration-300"
              title="Close"
              onClick={handleClose}
            >
              <MdOutlineCancel size={24} color={currentColor}/>
            </button>
          </div>
              
          <div className=" mx-4 text-white">
            <Header category="Purchases" title="Pay for Purchase" color={currentColor}/>
          </div>
        </div>

        {/* Loading State */}
        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <Audio height="80" width="80" radius="9" color="white" ariaLabel="loading" />
            <p className="mt-4 text-white">Processing payment...</p>
          </div>
        ) : (
          <div className="bg-white p-6 my-4 rounded-xl max-w-5xl mx-auto shadow-2xl grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Supplier Information Section */}
             {/* Payment Status and Date Section */}
            <div className="col-span-2 bg-gray-200 rounded-lg shadow-md text-gray-800">
              <div className="flex justify-between p-4">
                <div className="flex justify-between text-sm">
                  {/* Submit and Close Button */}
                  <div className="w-full flex justify-end">
  <>
    <button
      onClick={handleSubmit}
      className="text-white px-3 py-2 rounded-lg flex bg-green-500 hover:bg-blue-600 transition-all duration-300 transform hover:scale-105"
    >
      <FaSackDollar size={25} />
      <span>PAY</span>
    </button>
  </>
</div>

                  </div>
                
              </div>
            </div>

            {/* supplier information */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Supplier Information</p>
              <div className="space-y-1">
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Supplier Name:</label>
                  <span>{pay?.invoice?.partners?.name || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Contact Person:</label>
                  <span>{pay?.invoice?.partners?.contact_person || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Phone:</label>
                  <span>{pay?.invoice?.partners?.phone_number || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Email:</label>
                  <span>{pay?.invoice?.partners?.email || 'N/A'}</span>
                </div>
              </div>
            </div>
             {/* End Supplier Information Section */}

            {/* Invoice Information Section */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Invoice Details</p>
              <div className="space-y-1">
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Invoice No:</label>
                  <span>{pay?.invoice?.invoice_no}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Date:</label>
                  <span>{formatMediumDate(pay?.invoice?.date)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Due Date:</label>
                  <span>{formatMediumDate(pay?.invoice?.due_date)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Order ID:</label>
                  <span>{pay?.invoice?.p_orders?.reference}</span>
                </div>
               
                <div className="flex justify-between py-2 font-semibold text-lg border-t mt-4 text-gray-800">
                  <span>Invoice Amount:</span>
                  <span>{formattedGrandTotal}</span>
                </div>
              </div>
            </div>
            {/* End Invoice SInformation Section */}
            {/* supplier information */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Payment Information</p>
              <div className="space-y-1">
                
                {/* Installment Option */}
                <div className="flex items-center\">
                    <input
                      type="checkbox"
                      checked={isInstallment}
                      onChange={() => handlePaymentChange('installments', !isInstallment)}  // Call handlePaymentChange with 'installments' field
                      className="mr-2"
                    />
                    <label className="text-sm text-gray-700 font-semibold">Paying in Installments</label>
                  </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Payment Method:</label>
                  <span>{formattedPaymentMethods.find(method => method.value === pay.method_id)?.label || ''}</span>
             
                </div>
          
                                   
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Amount:</label>
                  <span>{pay.amount || 'N/A'}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Created Date:</label>
                  <span>{formatMediumDate(pay?.date || 'N/A')}</span>
                </div>
               
                <div className="flex justify-between text-sm">
                  <label className="font-medium">Status:</label>
                  <span
                    className={`uppercase font-bold ml-2 ${
                      pay?.state === 'draft'
                      ? 'text-yellow-700'
                      : pay?.state === 'approved'
                      ? 'text-blue-600'
                      : pay?.state === 'cancelled'
                      ? 'text-red-600'
                      : pay?.state === 'deleted'
                      ? 'text-gray-400'
                      : pay?.state === 'paid'
                      ? 'text-green-600'
                      : 'text-yellow-500' // Default to yellow for 'Pending' or unassigned states
                    }`}
                  >
                    {pay?.state || 'Pending'}
                  </span>
                </div>

       
                  
              </div>
            </div>
             {/* End Payment Information Section */}

            {/* Payee Information Section */}
            <div className="bg-gray-100 p-2 rounded-lg shadow-md text-gray-800">
              <p className="text-lg text-center font-bold mb-2">Payee Details</p>
              <div className="space-y-1">
                

                 {/* Payment Method is cash */}
                 {payment.method_id === 1 && (
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Payee Full Name</label>
                    <span>{pay?.method_details?.payee_name}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Identification  Type:</label>
                    <span>{pay?.method_details?.id_type}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Identification Number:</label>
                    <span>{pay?.method_details?.id_no}</span>
                  </div>

                  
                  </>
               
                )}

                {/* Payment by bank transfer */}
                {payment.method_id === 2 && (
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Account #</label>
                    <span>{pay?.payee?.account_no}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Name:</label>
                    <span>{pay?.payee?.bank_name}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Branch:</label>
                    <span>{pay?.payee?.bank_branch}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Account Holder</label>
                    <span>{pay?.payee?.account_holder}</span>
                  </div>
                  
                  
                  </>
               
                )}

                {/* Payment by credit card  */}
                {payment.method_id === 3 && (
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Card Number</label>
                    <span>{pay?.payee?.credit_card_number}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Expiration Date:</label>
                    <span>{pay?.payee?.expiration_date}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">CVV:</label>
                    <span>{pay?.payee?.cvv}</span>
                  </div>
                  </>
               
                )}
                {/* Payment by paypal  */}
                {payment.method_id === 4 && (
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">PayPal Email</label>
                    <span>{pay?.payee?.PayPal_email}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Currency:</label>
                    <span>{pay?.payee?.currency}</span>
                  </div>
                  </>
               
                )}
                {/* Payment by cheque  */}
                {payment.method_id === 5 && (
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Cheque Number.</label>
                    <span>{pay?.payee?.cheque_no}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Name:</label>
                    <span>{pay?.payee?.bank_name}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Branch:</label>
                    <span>{pay?.payee?.bank_branch}</span>
                  </div>
                  </>
               
                )}

                {/* Payment by cheque  */}
                {payment.method_id === 5 && (
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Cheque Number.</label>
                    <span>{pay?.payee?.cheque_no}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Name:</label>
                    <span>{pay?.payee?.bank_name}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Branch:</label>
                    <span>{pay?.payee?.bank_branch}</span>
                  </div>
                  </>
               
                )}
                  {/* Payment by mobile money */}
                  {payment.method_id === 6 && (
                  <>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Mobile Number.</label>
                    <span>{pay?.payee?.cheque_no}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Bank Name:</label>
                    <span>{pay?.payee?.mobile_number}</span>
                  </div>

                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Service Provider:</label>
                    <span>{pay?.payee?.service_provider}</span>
                  </div>
                  </>
               
                )}


                

                
               
               
               
              </div>
            </div>
            
            {/* End Payee Information Section */}
            {/* Payment Information Section */}
            
          </div>
        )}
      </div>
    </Layout>
  );
};
export default Pay;
